const mrSliders = () => {
  if (window.template_type !== 'collection') {
    const width = $(window).width();
    function initSlick() {
      const heroEl = '[id*=mr-hero-slider-]';
      if ($(`${heroEl}.slick-initialized`).length <= 0) {
        let settings = {
          arrows: false,
          dots: true,
          draggable: true,
          verticalSwiping: true,
          autoplay: false,
          autoplaySpeed: 5000,
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          cssEase: 'linear',
          prevArrow: `<img class='slick-prev' src='//cdn.shopify.com/s/files/1/0622/3416/5414/t/105/assets/icon-arrow-light.svg'>`,
          nextArrow: `<img class='slick-next' src='//cdn.shopify.com/s/files/1/0622/3416/5414/t/105/assets/icon-arrow-light.svg'>`,
        };
        if ($(window).width() <= 768) {
          settings = {
            dots: true,
            arrows: false,
            draggable: true,
            verticalSwiping: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: `<img class='slick-prev' src='//cdn.shopify.com/s/files/1/0622/3416/5414/t/105/assets/icon-arrow-light.svg'>`,
            nextArrow: `<img class='slick-next' src='//cdn.shopify.com/s/files/1/0622/3416/5414/t/105/assets/icon-arrow-light.svg'>`,
          };
        }
        $(heroEl).slick(settings);
      }
    }
    function productSlider(force = false) {
      const sliderSelector = '[id*=mr-custom-product-slider-] ul.product-grid';
      $(sliderSelector).each((index, element) => {
        const itemsCount = $(element).find('li.product-item-slide').length;
        if ($(element).is('.slick-initialized') === false || force === true) {
          let settings = {
            slidesToShow: itemsCount < 4 ? itemsCount : 4,
            slidesToScroll: 3,
            arrows: true,
            dots: itemsCount > 4,
            draggable: true,
            mobileFirst: false,
            infinite: false,
            prevArrow: `<span class='slick-prev'><svg xmlns="http://www.w3.org/2000/svg" width="30" height="13" viewBox="0 0 30 13" fill="none">
                    <path d="M29.1 7.06237V7.16237H29L3.3838 7.16237L7.33817 11.1343L7.40843 11.2048L7.33816 11.2754L6.54625 12.0706L6.47538 12.1417L6.40452 12.0706L0.929131 6.57055L0.858895 6.5L0.929131 6.42945L6.40452 0.929448L6.47538 0.858274L6.54625 0.929436L7.33816 1.72463L7.40843 1.79518L7.33817 1.86575L3.3838 5.83763L29 5.83763H29.1V5.93763V7.06237Z" fill="black" stroke="black" stroke-width="0.2"/>
                    </svg></span>`,
            nextArrow: `<span class='slick-next'><svg xmlns="http://www.w3.org/2000/svg" width="30" height="13" viewBox="0 0 30 13" fill="none">
                    <path d="M0.9 5.93763V5.83763H1H26.6162L22.6618 1.86575L22.5916 1.79518L22.6618 1.72463L23.4538 0.929436L23.5246 0.858273L23.5955 0.929448L29.0709 6.42945L29.1411 6.5L29.0709 6.57055L23.5955 12.0706L23.5246 12.1417L23.4538 12.0706L22.6618 11.2754L22.5916 11.2048L22.6618 11.1343L26.6162 7.16237H1H0.9V7.06237V5.93763Z" fill="black" stroke="black" stroke-width="0.2"/>
                    </svg></span>`,
          };

          // mobile screens
          if (width <= 768) {
            settings = {
              arrows: false,
              vertical: false,
              dots: true,
              draggable: true,
              infinite: false,
              centerMode: false,
              adaptiveHeight: true,
              slidesToShow: 1,
              rows: 2,
              slidesPerRow: 1,
              verticalSwiping: false,
            };

            // tablet screens
          } else if (width <= 820) {
            settings.slidesToShow = itemsCount < 3 ? itemsCount : 3;

            // larger screens
          } else if (width >= 2000) {
            settings.slidesToShow = itemsCount < 5 ? itemsCount : 5;
          }
          if ($(element).is('.slick-initialized') === true) {
            $(element).slick('unslick');
          }
          $(element).slick(settings);
        }
      });
    }

    function customSlider(force = false) {
      const sliderSelector = '[id*=mr-custom-blog-slider-] ul.product-grid';
      $(sliderSelector).each((index, element) => {
        const itemsCount = $(element).find('li.product-item-slide').length;
        if ($(element).is('.slick-initialized') === false || force === true) {
          let settings = {
            slidesToShow: itemsCount < 4 ? itemsCount : 4,
            slidesToScroll: 3,
            arrows: true,
            dots: false,
            draggable: true,
            mobileFirst: false,
            infinite: false,
            prevArrow: `<span class='slick-prev'><svg xmlns="http://www.w3.org/2000/svg" width="30" height="13" viewBox="0 0 30 13" fill="none">
                    <path d="M29.1 7.06237V7.16237H29L3.3838 7.16237L7.33817 11.1343L7.40843 11.2048L7.33816 11.2754L6.54625 12.0706L6.47538 12.1417L6.40452 12.0706L0.929131 6.57055L0.858895 6.5L0.929131 6.42945L6.40452 0.929448L6.47538 0.858274L6.54625 0.929436L7.33816 1.72463L7.40843 1.79518L7.33817 1.86575L3.3838 5.83763L29 5.83763H29.1V5.93763V7.06237Z" fill="black" stroke="black" stroke-width="0.2"/>
                    </svg></span>`,
            nextArrow: `<span class='slick-next'><svg xmlns="http://www.w3.org/2000/svg" width="30" height="13" viewBox="0 0 30 13" fill="none">
                    <path d="M0.9 5.93763V5.83763H1H26.6162L22.6618 1.86575L22.5916 1.79518L22.6618 1.72463L23.4538 0.929436L23.5246 0.858273L23.5955 0.929448L29.0709 6.42945L29.1411 6.5L29.0709 6.57055L23.5955 12.0706L23.5246 12.1417L23.4538 12.0706L22.6618 11.2754L22.5916 11.2048L22.6618 11.1343L26.6162 7.16237H1H0.9V7.06237V5.93763Z" fill="black" stroke="black" stroke-width="0.2"/>
                    </svg></span>`,
          };

          // mobile screens
          if (width <= 768) {
            settings = {
              arrows: false,
              vertical: false,
              dots: true,
              draggable: true,
              infinite: false,
              centerMode: false,
              adaptiveHeight: true,
              slidesToShow: 1,
              rows: 2,
              slidesPerRow: 1,
              verticalSwiping: false,
            };

            // tablet screens
          } else if (width <= 820) {
            settings.slidesToShow = itemsCount < 3 ? itemsCount : 3;

            // larger screens
          } else if (width >= 2000) {
            settings.slidesToShow = itemsCount < 5 ? itemsCount : 5;
          }
          if ($(element).is('.slick-initialized') === true) {
            $(element).slick('unslick');
          }
          $(element).slick(settings);
        }
      });
    }

    productSlider();
    customSlider();
    initSlick();

    $(window).on('scroll', () => {
      initSlick();
      productSlider();
      customSlider();
    });

    // Trigger slick in homepage hero banner when customizing theme
    $(window).on('shopify-custom-section-slider-event', function () {
      initSlick();
      productSlider(true);
      customSlider(true);
    });

    // Trigger slick intentionally
    $(window).on('custom-trigger-section-slider-event', function () {
      initSlick();
      productSlider(true);
      customSlider(true);
    });

    setTimeout(() => {
      $(window).trigger('scroll');
    }, 100);
  }
};

export default mrSliders;
